import { StyleSheet } from 'aphrodite';
import { destructiveHover, error, inputBorderColor, label, navigation, titles, white } from '../../../styles/colors';
import { CssSelectors, baseStyles } from '../../../styles/styles';
import { SPACE, THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	consentCheckbox: {
		color: titles,
	},
	imagePlaceholder: {
		bottom: -20,
		color: navigation,
		fontSize: 14,
		fontStyle: 'italic',
		height: 20,
		maxWidth: 190,
		position: 'absolute',
		right: 0,
		top: 5,
	},
	infoList: {
		listStyleType: '"-"',
		...CssSelectors.allChildren(
			{
				listStyleType: '"-"',
			},
			'li'
		),
		...CssSelectors.allChildren(
			{
				...baseStyles.mt2,
			},
			'li:not(:first-child)'
		),
	},
	consentBox: {
		'::-webkit-scrollbar': {
			background: 'transparent',
			width: 4,
		},
		'::-webkit-scrollbar-thumb': {
			backgroundColor: inputBorderColor,
			borderRadius: 10,
			padding: 4,
		},
	},
	consentList: {
		listStyleType: '"-"',
		...CssSelectors.allChildren(
			{
				listStyleType: '"-"',
			},
			'li'
		),
		...CssSelectors.allChildren(
			{
				...baseStyles.mt1,
			},
			'li:not(:first-child)'
		),
	},
	headline: {
		fontSize: 18,
	},
	subHeadline: {
		color: label,
		fontSize: 14,
		textAlign: 'center',
	},
	addressLineCol: {
		flex: 1,
	},
	addressLineGroup: {
		display: 'flex',
		...CssSelectors.allChildren(
			{
				marginLeft: '0.5rem',
			},
			':not(:first-child)'
		),
	},
	containerHeader: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 30,
	},
	formContainer: {
		background: '#f9f9f9',
		margin: 'auto',
		padding: 50,
		width: 600,
	},
	formErrorLine: {
		color: error,
		fontSize: '0.75rem',
		marginTop: 0,
	},
	formField: {
		background: white,
		...CssSelectors.allDescendants(
			{
				background: white,
			},
			'.select-box-trigger, .select-box-trigger:hover'
		),
	},
	formFieldReadOnly: {
		background: THEME.colors.background.main,
		color: THEME.colors.text.light,
		cursor: 'not-allowed',
	},
	formFooter: {
		display: 'flex',
		marginTop: 30,
		...CssSelectors.allDescendants(
			{
				width: '100%',
			},
			'button'
		),
	},
	label: {
		color: label,
		display: 'block',
		fontSize: 14,
		letterSpacing: 0,
		marginBottom: 5,
		marginTop: 15,
	},
	labelRequired: {
		'::after': {
			color: destructiveHover,
			content: '"*"',
			display: 'inline',
			marginLeft: '0.25rem',
		},
	},
	verbalScriptPanel: {
		backgroundColor: THEME.colors.background.main,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[16],
		marginTop: SPACE[16],
		padding: SPACE[16],
	},
	verbalScriptPanelUpdating: {
		opacity: 0.6,
	},
	verbalScriptStep: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[8],
	},
	verbalScriptStepHeader: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[8],
		justifyContent: 'space-between',
	},
	verbalScriptHeading: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		margin: 0,
	},
	verbalScriptText: {
		backgroundColor: THEME.colors.background.light,
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
		padding: SPACE[12],
		whiteSpace: 'pre-wrap',
	},
	verbalScriptNote: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
	verbalScriptError: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.sm,
		margin: 0,
	},
	verbalScriptSkeleton: {
		height: SPACE[64],
	},
});
